import ApiService from '../apiservice'

export default class ConfiuracaoProcessoParadoService extends ApiService {
  constructor() {
    super('/configuracao-processo-parado');
  }

  consultar(empresa) {
    return this.get(`/${empresa}`);
  }

  alterar(configuracao) {
    return this.put('/',configuracao);
  }
}